import { Page, Resource as T } from '../../../../types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'
import { FilterValue, applySearchParams, responseToPage, urlToPathnameAndSearch } from '../utils'

type Filter = 'country' | 'journey' | 'id' | 'is_active' | 'gid' | 'shop_id' | 'state' | 'type' | 'page_size'
type Filters = Partial<Record<Filter, FilterValue>>

const pathname = `/api/${apiVersion}/resources`

const makeGet =
  (baseUrl: string, config: HttpClientConfig) =>
  async (filters: Filters): Promise<Page<T>> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, { page_size: 100, ...filters })

    const pathnameAndSearch = urlToPathnameAndSearch(url)
    const response = await service(baseUrl).get(pathnameAndSearch, config)

    return responseToPage<T>(response)
  }

export { makeGet as makeGetResources }
export type { Filters as ResourcesFilters }
